module.exports = __webpack_public_path__ + "img/Weapon_253.9193d317.png";